import Http from '../http'
// 报表统计模块API
export default {
  getReportList(params) {
    return Http.post('/normal/daily.do', params)
  },
  getDeviceList(params) {
    return Http.post('device/list.do', params)
  },
  // 二级账户列表
  getSecondAccount() {
    return Http.post('/index/allCompany.do')
  },
  // 二级账号下的子账户
  getSecondChildren(params) {
    return Http.post('/user/allUser.do', params)
  },
  // 常用报表-里程汇总报表
  getNormalSummery(params) {
    return Http.post('/normal/summary1.do', params)
  },
  // 常用报表-里程日报表
  getNormalDetail(params) {
    return Http.post('/normal/daily.do', params)
  },
  // 常用报表-导出里程汇总报表
  exportNormalSummery() {
    return '/export/normalSummary.do'
  },
  // 常用报表-导出里程日报表
  exportNormalDetail() {
    return '/export/normalDaily.do'
  },
  // 速度报表---超速报警汇总表
  getSpeed1(params) {
    return Http.post('/speed/summary.do', params)
  },
  // 速度报表---超速报警明细表
  getSpeed2(params) {
    return Http.post('/speed/daily.do', params)
  },
  // 速度报表---行驶速度分析
  getSpeed3(params) {
    return Http.post('/speed/trackDetail.do', params)
  },
  // 速度报表---导出超速报警汇总表
  exportSpeed1() {
    return '/export/speedSummary.do'
  },
  // 速度报表---导出超速报警明细表
  exportSpeed2() {
    return '/export/speedDaily.do'
  },
  // 速度报表---导出行驶速度分析
  exportSpeed3() {
    return '/export/speedDetail.do'
  },
  // 上下线报表---上线率报表
  getOnOff1(params) {
    return Http.post('/online/daily.do', params)
  },
  // 上下线报表---上下线汇总表
  getOnOff2(params) {
    return Http.post('/online/summary.do', params)
  },
  // 上下线报表---上下线明细表
  getOnOff3(params) {
    return Http.post('/online/detail.do', params)
  },
  // 导出 上线率报表
  exportOnOff1() {
    return '/export/onlineDaily.do'
  },
  // 导出 上下线汇总表
  exportOnOff2() {
    return '/export/onlineSummary.do'
  },
  // 导出 上下线明细表
  exportOnOff3() {
    return '/export/onlineDetail.do'
  },
  // 司机出勤报表---司机出勤统计报表
  driverAttend1(params) {
    return Http.post('/driver/summary.do', params)
  },
  // 司机出勤报表---司机出勤明细报表
  driverAttend2(params) {
    return Http.post('/driver/detail.do', params)
  },
  // 导出 司机出勤统计报表
  exportDriverAttend1() {
    return '/export/driverSummary.do'
  },
  // 导出 司机出勤明细报表
  exportDriverAttend2() {
    return '/export/driverDetail.do'
  },
  // IO输入报警报表---IO输入报警汇总报表
  ioInput1(params) {
    return Http.post('/ioin/summary.do', params)
  },
  // IO输入报警报表---IO输入报警明细报表
  ioInput2(params) {
    return Http.post('/ioin/daily.do', params)
  },
  // 导出 IO输入报警汇总报表
  exportIoInput1() {
    return '/export/ioinSummary.do'
  },
  // 导出 IO输入报警明细报表
  exportIoInput2() {
    return '/export/ioinDaily.do'
  },
  // 报警报表---报警汇总报表
  alarm1(params) {
    return Http.post('/alarm/summary.do', params)
  },
  // 报警报表---报警明细报表
  alarm2(params) {
    return Http.post('/alarm/detail.do', params)
  },
  // 删除 设备离线升级记录、参数配置报表
  deleteDevUpdate(params) {
    return Http.post('/distinct/deleteDevOflTask.do', params)
  },
  // 报警报表---报警明细报表 未打表
  alarmConfirm(params) {
    return Http.post('/alarm/detailConfirm.do', params)
  },
  // 报警报表---乘客超员记录表
  record(params) {
    return Http.post('/record/detail.do', params)
  },
  // 导出 乘客超员记录表
  exportRecord() {
    return '/record/detailExport.do'
  },
  // 导出 报警汇总报表
  exportAlarm1() {
    return '/export/alarmSummary.do'
  },
  // 导出 报警明细报表
  exportAlarm2() {
    return '/export/detailExport.do'
  },
  // 导出 报警明细报表
  exportConfirmAlarm() {
    return '/export/detailConfirmExport.do'
  },
  // 客流统计---客流量统计
  traffic1(params) {
    return Http.post('/passenger/detail.do', params)
  },
  // 客流统计---客流量查询
  traffic2(params) {
    return Http.post('/passenger/flow.do', params)
  },
  // 客流统计---客流量统计
  traffic3(params) {
    return Http.post('/passenger/detailnew.do', params)
  },
  // 客流统计---客流量查询
  traffic4(params) {
    return Http.post('/passenger/flownew.do', params)
  },
  // 导出 客流量统计
  exportTraffic1() {
    return '/export/passengerDetail.do'
  },
  // 导出 客流量统计
  exportTraffic3() {
    return '/export/passengerDetailNew.do'
  },
  // 导出 客流量查询
  exportTraffic2() {
    return '/export/passengerFlow.do'
  },
  // 存储介质报表---存储介质、硬盘超温、硬盘状态信息报警明细表
  hardWare(params) {
    return Http.post('/hardWare/detail.do', params)
  },
  // 导出 存储介质报表、硬盘超温、硬盘状态信息报警明细表
  exportHardWare() {
    return '/export/hardExport.do'
  },
  // TODO
  // exportHardWare (params) {
  //   return Http.post('/export/hardExport.do', params)
  // },
  // 设备升级报表---车辆版本明细表
  devUpdate1(params) {
    return Http.post('/distinct/detail.do', params)
  },
  // 设备升级报表---设备离线升级记录、参数配置报表
  devUpdate2(params) {
    return Http.post('/distinct/daily.do', params)
  },
  // 设备升级报表---设备离线升级状态
  status(params) {
    return Http.post('/distinct/status.do', params)
  },
  // 设备升级报表---车辆MCU报表
  devUpdate3(params) {
    return Http.post('/distinct/mcuDetail.do', params)
  },
  // 导出 车辆版本明细
  exportDevUpdate1() {
    return '/export/distinctDetail.do'
  },
  // 导出 设备离线升级记录、参数配置报表
  exportDevUpdate2() {
    return '/export/distinctDaily.do'
  },
  // 导出 车辆MCU报表
  exportDevUpdate3() {
    return '/export/mcuExport.do'
  },
  // 油量报表-油量动态明细表
  oilD1(params) {
    return Http.post('/oil/trackDetail.do', params)
  },
  // 油量报表-油量异常明细表
  oilD2(params) {
    return Http.post('/oil/exceptionDetail.do', params)
  },
  // 油量报表-油量日统计表
  oilD3(params) {
    return Http.post('/oil/summary.do', params)
  },
  // 导出 油量动态明细表
  exportOilD1() {
    return '/export/oilDetail.do'
  },
  // 导出 油量异常明细表
  exportOilD2() {
    return '/export/exceptionDetail.do'
  },
  // 导出 油量日统计表
  exportOilD3() {
    return '/export/oilSummary.do'
  },
  // 停车报表-停车未熄火汇总、超时停车汇总表
  parking1(params) {
    return Http.post('/park/summary.do', params)
  },
  // 停车报表-停车未熄火明细、超时停车明细表
  parking2(params) {
    return Http.post('/park/detail.do', params)
  },
  // 导出 停车未熄火汇总、超时停车汇总表
  exportParking1() {
    return '/export/parkSummary.do'
  },
  // 导出 停车未熄火汇总、超时停车汇总表
  exportParking2() {
    return '/export/parkDetail.do'
  },
  // 电子围栏-围栏报警明细表
  fenceDetail(params) {
    return Http.post('/fence/detail.do', params)
  },
  // 导出 围栏报警明细表
  exportFenceDetail() {
    return '/export/fenceDetail.do'
  },
  // 电子围栏-围栏报警汇总
  fenceSummary(params) {
    return Http.post('/fence/summary.do', params)
  },
  // 导出 围栏报警汇总
  exportFenceSummary() {
    return '/export/exportFenceSummary.do'
  },
  // 调度报表-TTS明细表
  TTS(params) {
    return Http.post('/tts/detail.do', params)
  },
  // 导出 TTS明细表
  exportTTS() {
    return '/export/ttsDetail.do'
  },
  // 胎压报表-胎压传感器明细表
  tyreDetail(params) {
    return Http.post('/tyre/detail.do', params)
  },
  // 导出 胎压传感器明细表
  exportTyreDetail() {
    return '/tyre/export.do'
  },
  // 学生统计报表(ODM需求)
  studentStatistics(params) {
    return Http.post('/student/detail.do', params)
  },
  // 学生统计报表(ODM需求)
  drivingrecord(params) {
    return Http.post('/normal/getDrivingrecord.do', params)
  },
  // 导出学生统计报表
  exportStudentStatistics() {
    return '/export/studentExport.do'
  },
  // 导出行驶记录仪采集记录表
  exportDrivingrecord() {
    return '/export/getDrivingrecord.do'
  },
  // ETC管理
  etcrecord(params) {
    return Http.post('/etc/getDevEtcCardList.do', params)
  },
  // 导出 ETC管理
  exportETCRecord() {
    return '/export/getDevEtcCardList.do'
  },
  // ETC交易信息管理
  etcBillrecord(params) {
    return Http.post('/etc/getDevEtcDealList.do', params)
  },
  // 导出 ETC交易信息管理
  exportETCBillRecord() {
    return '/export/getDevEtcDealList.do'
  },
  // 多媒体-图片
  multimidea1(params) {
    return Http.post('/media/photoDetail.do', params)
  },
  // 多媒体-音频
  multimidea2(params) {
    return Http.post('/media/voiceDetail.do', params)
  },
  // 多媒体-视频
  multimidea3(params) {
    return Http.post('/media/videoDetail.do', params)
  },
  // ADAS报警明细表
  adas1(params) {
    return Http.post('/driver/warnings.do', params)
  },
  // ADAS报警图片表
  adas2(params) {
    return Http.post('/driver/photoDetail.do', params)
  },
  // ADAS报警统计表
  adas3(params) {
    return Http.post('/driver/warningsByCount.do', params)
  },
  // 导出 ADAS报警明细表
  exportAdas1() {
    return '/export/warnings.do'
  },
  // 苏标ADAS报警明细表
  subAdas1(params) {
    return Http.post('/adas/list.do', params)
  },
  // 苏标ADAS报警明细表
  subAdas2(params) {
    return Http.post('/adas/summary.do', params)
  },
  // 苏标ADAS查看图片视频
  subAdas3(params) {
    return Http.post('/file/download.do', params)
  },
  // 导出 苏标ADAS报警明细表
  exportSubAdas1() {
    return '/export/exportAdas.do'
  },
  // DSM报表-DSM明细表
  dsm1(params) {
    return Http.post('/dsm/list.do', params)
  },
  // DSM报表-DSM统计表
  dsm2(params) {
    return Http.post('/dsm/summary.do', params)
  },
  // 导出 DSM明细表
  exportDsm1() {
    return '/export/exportDsm.do'
  },
  // 导出 人脸识别明细表
  exportRaceRecognition() {
    return '/export/exportFaceMisMatch.do'
  },
  // 用户行为分析-用户操作汇总
  behave1(params) {
    return Http.post('/log/summary.do', params)
  },
  // 用户行为分析-用户操作日志
  behave2(params) {
    return Http.post('/user/logQuery.do', params)
  },
  // 用户行为分析-用户媒体汇总
  behave3(params) {
    return Http.post('/log/mediaLogSummary.do', params)
  },
  // 用户行为分析-用户媒体明细
  behave4(params) {
    return Http.post('/log/mediaLog.do', params)
  },
  // 用户行为分析-设备变更报表
  behave5(params) {
    return Http.post('/log/devChange.do', params)
  },
  // 导出 用户操作汇总
  exportBehave1() {
    return '/export/userSummary.do'
  },
  // 导出 用户操作日志
  exportBehave2() {
    return '/export/logExport.do'
  },
  // 导出 用户媒体汇总
  exportBehave3() {
    return '/export/mediaSummaryExport.do'
  },
  // 导出 用户媒体明细
  exportBehave4() {
    return '/export/mediaLog.do'
  },
  // 导出 设备变更报表
  exportBehave5() {
    return '/export/devChange.do'
  },
  // 音视频资源文件-音视频资源明细报表
  VideoDeta1(params) {
    return Http.post('/media/videoDetail.do', params)
  },
  // 音视频资源文件-音视频资源汇总报表
  VideoDeta2(params) {
    return Http.post('/media/videoSummary.do', params)
  },
  // 导出 音视频资源明细报表
  exportVideoDeta1() {
    return '/media/exportVideoDetail.do'
  },
  // 导出 音视频资源汇总报表
  exportVideoDeta2() {
    return '/media/exportVideoSummary.do'
  },
  // 营运订单-日营运统计(出租车)
  dailyOperating(params) {
    return Http.post('/taxi/getOperationByDay.do', params)
  },
  // 导出-营运订单-日营运统计(出租车)
  exportDailyOperating() {
    return '/export/getOperationByDay.do'
  },
  // 营运订单-月营运统计(出租车)
  monthlyOperating(params) {
    return Http.post('/taxi/getOperationByMonths.do', params)
  },
  // 导出-营运订单-月营运统计(出租车)
  exportMonthlyOperating() {
    return '/export/getOperationByMonths.do'
  },
  // 营运订单-年营运统计(出租车)
  yearOperating(params) {
    return Http.post('/taxi/getOperationByYear.do', params)
  },
  // 导出-营运订单-年营运统计(出租车)
  exportYearOperating() {
    return '/export/getOperationByYear.do'
  },
  // 营运订单-营运交易类型统计(出租车)
  getOperationByTradetype(params) {
    return Http.post('/taxi/getOperationByTradetype.do', params)
  },
  // 导出-营运订单-营运交易类型统计(出租车)
  exportOperationByTradetype() {
    return '/export/getOperationByTradetype.do'
  },
  // 营运订单-营运订单明细查询(出租车)
  getOperation(params) {
    return Http.post('/taxi/getOperation.do', params)
  },
  // 导出-营运订单明细查询(出租车)
  exportGetOperation() {
    return '/export/getOperation.do'
  },
  // 营运订单-设备营运统计(出租车)
  equipmentOperation(params) {
    return Http.post('/taxi/getOperationByIdno.do', params)
  },
  // 导出-设备营运统计(出租车)
  exportEquipmentOperation() {
    return '/export/getOperationByIdno.do'
  },
  // 电召订单-电召订单业务类型统计(出租车)
  businessType(params) {
    return Http.post('/taxi/getOrderByBustype.do', params)
  },
  // 导出-电召订单-电召订单业务类型统计(出租车)
  exportBusinessType() {
    return '/export/getOrderByBustype.do'
  },
  // 电召订单-电召订单明细查询(出租车)
  orderDetail(params) {
    return Http.post('/taxi/getOrders.do', params)
  },
  // 导出-电召订单-电召订单明细查询(出租车)
  exportOrderDetail() {
    return '/export/getOrders.do'
  },
  // 电召订单-电召订单年营运统计(出租车)
  getOrderByYear(params) {
    return Http.post('/taxi/getOrderByYear.do', params)
  },
  // 导出-电召订单-电召订单年营运统计(出租车)
  exportOrderByYear() {
    return '/export/getOrderByYear.do'
  },
  // 电召订单-电召订单月营运统计(出租车)
  getOrderByMonths(params) {
    return Http.post('/taxi/getOrderByMonths.do', params)
  },
  // 导出-电召订单-电召订单月营运统计(出租车)
  exportOrderByMonths() {
    return '/export/getOrderByMonths.do'
  },
  // 电召订单-电召订单日营运统计(出租车)
  getOrderByDay(params) {
    return Http.post('/taxi/getOrderByDay.do', params)
  },
  // 导出-电召订单-电召订单日营运统计(出租车)
  exportGetOrderByDay() {
    return '/export/getOrderByDay.do'
  },
  // 电召订单-电召订单状态统计(出租车)
  getOrderByFlag(params) {
    return Http.post('/taxi/getOrderByFlag.do', params)
  },
  // 导出-电召订单-电召订单状态统计(出租车)
  exportGetOrderByFlag() {
    return '/export/getOrderByFlag.do'
  },
  // 电召订单-电召订单设备统计(出租车)
  getOrderByIdno(params) {
    return Http.post('/taxi/getOrderByIdno.do', params)
  },
  // 导出-电召订单设备统计(出租车)
  exportGetOrderByIdno() {
    return '/export/getOrderByIdno.do'
  },
  // 设备指令下发报表-(出租车)
  commandSend(params) {
    return Http.post('/taxi/getRecords.do', params)
  },
  // 导出-设备指令下发报表-(出租车)
  exportCommandSend() {
    return '/export/getRecords.do'
  },
  // 设备文本下发报表-(出租车)
  commandSendText(params) {
    return Http.post('/taxi/getDeviceSendText.do', params)
  },
  // 导出-设备文本下发报表-(出租车)
  exportCommandSendText() {
    return '/export/getDeviceSendText.do'
  },
  // 营运订单-订单状态统计(出租车)---暂时不用该接口
  orderStatus(params) {
    return Http.post('/taxi/getOperationByFlag.do', params)
  },
  // 订单评价
  getComment(params) {
    return Http.post('taxi/getCommList.do', params)
  },
  // 导出-订单评价
  exportGetComment() {
    return 'export/getCommList.do'
  },
  // 投诉登记
  getComplaints(params) {
    return Http.post('taxi/getComplaints.do', params)
  },
  // 导出-投诉登记
  exportComplaints() {
    return 'export/getComplaints.do'
  },
  // 投诉登记获取
  getComplaintById(params) {
    return Http.post('taxi/getComplaintById.do', params)
  },
  // 司机驾驶时长
  getDrivingtimeByDay(params) {
    return Http.post('drivingTime/getDrivingtimeByDay.do', params)
  },
  // 驾驶时长报警明细表
  drivingTimeAlarm(params) {
    return Http.post('drivingTime/drivingTimeAlarm.do', params)
  },
  // 司机档案列表
  getDriverRecordList(params) {
    return Http.post('driver/list.do', params)
  },
  // 历史轨迹列表
  getHistoryTrace(params) {
    return Http.post('historyTrace/validHistoryTrace.do', params)
  },
  // 导出-历史轨迹列表
  exportHistoryTrace() {
    return 'export/validHistoryTrace.do'
  },
  // OBD
  getObdDetail(params) {
    return Http.post('obd/obdQuery.do', params)
  },
  // 导出-OBD
  exportObdDetail() {
    return 'export/obdQuery.do'
  },
  // 明细表
  iccid(params) {
    return Http.post('/normal/getIccid.do', params)
  },
  // 导出 明细表
  exportIccid() {
    return 'export/getIccid.do'
  },
  // 行驶时长明细
  getTravelTimeDtl(params) {
    return Http.post('/normal/travelTimeDtl.do', params)
  },
  // 导出 明细表
  exportTravelTimeDtl() {
    return 'export/exportTravelTimeDtl.do'
  },
  // 行驶时长汇总
  getTravelTimeSum(params) {
    return Http.post('/normal/travelTimeSum.do', params)
  },
  // 导出-行驶时长汇总
  exportexportTravelTimeDtl() {
    return '/export/exportTravelTimeDtl.do'
  },
  // 中俄数据交互---中俄数据交互数目
  getDataTraninfocount(params) {
    return Http.post('/dataTransInfo/list.do', params)
  },
  // 导出-中俄数据交互数目
  exportDataTransInfo() {
    return '/export/exportDataTransInfo.do'
  },
  // 中俄数据交互---进入中方的车辆数目
  getDataTraninfoToChinacount(params) {
    return Http.post('/dataTransInfo/toChinacount.do', params)
  },
  // 导出-进入中放数据交互数目
  exportToChinacount() {
    return '/export/exportToChinacount.do'
  },
  // 中俄数据交互---进入俄方的车辆数目
  getDataTraninfoToRussiacount(params) {
    return Http.post('/dataTransInfo/toRussiacount.do', params)
  },
  // 导出-进入俄方数据交互数目
  exportToRussiacount() {
    return '/export/exportToRussiacount.do'
  },
  // 中俄数据交互,用户
  getDataTraninfoUser(params) {
    return Http.post('/dataTransInfo/allUserInfo.do', params)
  },
  // 中俄数据交互发送数据包
  getDataTraninfoEx(params) {
    return Http.post('/dataTransInfo/dataTransInfoEx.do', params)
  },
  // 导出-中俄数据交互车辆发送数据包
  exportDataTransInfoEx() {
    return '/export/exportDataTransInfoEx.do'
  },
  // 获取终端列表
  getDeviceToRuList(params) {
    return Http.post('/dataTransInfo/allDeviceToRu.do', params)
  },
  // 获取轨迹
  getTraceList(params) {
    return Http.post('/historyTrace/getHistoryTrace.do', params)
  },
  // 导出轨迹
  exportTraceList() {
    return '/export/getHistoryTrace.do'
  },
  // 修改处理方式
  setState(params) {
    return Http.post('/webs/alarmHandle.do', params)
  },
  // 修改dsm处理方式
  setStateDsm(params) {
    return Http.post('/webs/alarmHandleDsm.do', params)
  },
  // 获取未打表报警-图表数据
  getChartData(params) {
    return Http.post('/analytic/getNoMarkingByYear.do', params)
  },
  // 物流锁-查询
  getLogisticsLockRecords(params) {
    return Http.post('/logisticsLock/getLogisticsLockRecords.do', params)
  },
  // 物流锁-导出
  exportLogisticsLockRecords() {
    return '/export/exportLogisticsLockRecords.do'
  },
  // 驾驶员不匹配
  DriverMismatchDetail(params) {
    return Http.post('/driverMismatch/getDriverMismatchDetail.do', params)
  },
  // 导出驾驶员不匹配
  exportDriverMismatch() {
    return '/driverMismatch/DriverMismatchDetailExport.do'
  },
  // 日本itsherpa-日报-报表
  workRecordList(params) {
    return Http.post('/itsherpa/workRecordList.do', params)
  },
  // 每日报告list表，货物状态等
  drivingStatusInfoList(params) {
    return Http.post('/itsherpa/drivingStatusInfoList.do', params)
  },
  // 折线图
  queryItsherpaStatusData(params) {
    return Http.post('/itsherpa/queryItsherpaStatusData.do', params)
  },
  // 查询行车状态
  queryItsherpaDeviceStatusData(params) {
    return Http.post('/itsherpa/queryItsherpaDeviceStatusData.do', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/reports.js